module.exports = __webpack_public_path__ + "static/media/ic_location_hollow.afe589a8.svg";